import React from 'react';
import {Button,Dialog,DialogTitle,DialogActions} from "@material-ui/core";
import {ChangeStatusLetter, removeCustomer} from "../../Utils/ChangeStatusCostumer";
import axios from 'axios';


const ConfirmedServed =({customer,customers,open,close,index,setAlertaTipo,setMensajeAlerta}) =>
{      
    const {name,dinersCount} = customer.data;

    const Confirm =async () =>
    {
        const {id} = customer;
        await removeCustomer(id);
        close();
    }

    const ConfirmWhatsapp =async () =>
    {
        const {id} = customer;
        if(index===1)
        {
            if(customers.length > 1)
            {

                window.axios.post("/whatsapp/siguiente",customers[1].data).then(() =>
                {
                    setAlertaTipo("success");
                    setMensajeAlerta(`Whatsapp siguiente enviado`);
                }).catch(error =>
                {
                    console.log(error);
                    setAlertaTipo("error");
                    setMensajeAlerta(`no se pudo enviar el whatsapp`);
                });
            }
        }
        await ChangeStatusLetter(id,"served","");
        close();
    }

    return <Dialog open={open} onClose={close}>
        <DialogTitle style={{textAlign:"center"}}>{`¿Desea eliminar a ${name} x ${dinersCount} de la lista?`}</DialogTitle>
           
        <div style={{padding:"10px"}}> 
            <div style={{display:"flex",justifyContent:"space-between",margin:"10px 0px"}}>
                <Button color="primary" variant="outlined" onClick={close}>Cancelar</Button>
                <Button color="primary" variant="contained" onClick={Confirm}>Confirmar</Button>
            </div>
            <div>  <Button style={{width:"100%"}} color="primary" variant="contained" onClick={ConfirmWhatsapp}>Confirmar y avisar siguiente</Button> </div>
        </div>
                
    </Dialog>
}

export default ConfirmedServed;